import {i18n} from '../i18n'

const translationKeys = {
    INVALID_PROFILE_LINK: 'errors.invalidProfileLink',
    EMAIL_ALREADY_IN_USE: 'errors.emailAlreadyInUse',
    GOOGLE_EMAIL_NOT_VERIFIED: 'errors.googleEmailNotVerified',
    RATE_LIMITED: 'errors.rateLimited',
    STORAGE_LIMIT_EXCEEDED: 'errors.storageLimitExceeded',
    UNKNOWN_ERROR: 'errors.unknown',
}

export const getApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data
    const translationKey = translationKeys[data?.error]
    return translationKey
        ? i18n.t(translationKey)
        : fallback
}
